/**
 * session.js
 * Written by: Li Liu
 */
import quizActions from '../../actions';
import questionActions from '../../../question/actions';
import userActions from '../../../user/actions';

export const initialState = {
  quizName: null,
  questionsIds: [],
  questionCount: 0,
  correct: 0,
  attempted: 0,
  hideMidStats: true,
};

const session = (state = initialState, action) => {
  const { questionsIds } = state;

  switch (action.type) {
    case userActions.LOAD_SESSION_START:
      return {
        ...state,
        hideMidStats: true,
      };
    case quizActions.SKIP_QUIZ_QUESTION:
      if (state.questionsIds.length >= 1) {
        return {
          ...state,
          questionsIds: questionsIds.concat(questionsIds.shift()),
        };
      }
      return state;
    case quizActions.GET_QUIZ_SUCCESS:
      // hasResult indicates that whether we have quiz result data in DB
      // If a new user signs up mid quiz, we do not overwrite his/her quiz progress
      // Instead, we just want to hide the MidQuizStats because they will be incorrect.
      if (action.hasAttempted || state.attempted === 0) {
        return {
          ...state,
          quizName: action.quiz.name,
          questionCount: action.quiz.question_count,
          questionsIds: action.quiz.questions.slice(0),
          hideMidStats: false,
        };
      }
      return {
        ...state,
        hideMidStats: true,
      };
    case questionActions.SUBMIT_QUESTION_SUCCESS:
      return {
        ...state,
        questionsIds: questionsIds.filter((val) => {
          return val !== action.id;
        }),
        attempted: state.attempted + 1,
        correct: action.result.played_answer.correct
          ? state.correct + 1
          : state.correct,
      };
    case questionActions.SUBMIT_QUESTION_FAILURE:
      return {
        ...state,
        questionsIds: questionsIds.filter((val) => {
          return val !== action.id;
        }),
      };
    case quizActions.GET_QUIZ_RESULTS_SUCCESS:
      return {
        ...state,
        attempted: action.results.attempted
          // If results has attempted information, then it means the user has played the quiz before
          // load the progress to session
          ? action.hideTrueResult
            ? state.attempted
            : action.results.attempted
          : state.hideMidStats || action.hideTrueResult
            // If results does not have attempted information,
            // then make sure we do not override progress if we are mid-quiz.
            ? state.attempted
            // If the user is not midQuiz, override the progress to 0
            : 0,
        correct: typeof action.results.correct !== `undefined`
          ? action.hideTrueResult
            ? state.correct
            : action.results.correct
          : state.hideMidStats || action.hideTrueResult
            ? state.correct
            : 0,
      };
    case userActions.LOGOUT_SUCCESS:
      return initialState;
    case quizActions.RESET_SESSION:
      return {
        ...initialState,
        hideMidStats: !action.loggedIn,
      };
    default:
      return state;
  }
};

export default session;
